import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { TextField, Fade, Paper, Button, Grid } from "@material-ui/core";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import SecondaryButton from 'components/Global/Buttons/SecondaryButton';
import SearchIcon from "@material-ui/icons/Search";
import styled from "styled-components";
import { getContacts, downloadContacts } from "store/state/contacts";
import ContactTable from "./Table";
import { getAllCompanies } from "store/state/companies";
import TablePaginationHelper from "../../../utils/tablePaginationHelper";

class Contacts extends Component {
  state = {
    orderDir: "asc",
    orderBy: "lastName",
    searchText: "",
  };

  tablePaginationHelper = new TablePaginationHelper("b662d317-ae67-4099-874b-10704f4c28b2", 10);

  componentDidMount() {
    this.props.getContacts({
      page: this.tablePaginationHelper.page,
      limit: this.tablePaginationHelper.rowsPerPage,
      orderDir: this.state.orderDir,
      orderBy: this.state.orderBy,
    });
    this.props.getAllCompanies({activeOnly: false});
  }
  download = () => {
    this.props.downloadContacts({
      page: this.tablePaginationHelper.page,
      limit: this.tablePaginationHelper.rowsPerPage
    });
  };
  handleChange = ({target: {name, value}}) => {
    this.setState({[name]: value});
  };

  handleKeyDown = (e)  => {    
    if (e.key === 'Enter') {
      this.search();
    }
  }

  handleChangeRowsPerPage = event => {
    this.tablePaginationHelper.rowsPerPage = event.target.value;
    this.forceUpdate();
  };

  search(){
    this.props.getContacts({
      page: this.tablePaginationHelper.page,
      limit: this.tablePaginationHelper.rowsPerPage,
      orderDir: this.state.orderDir,
      orderBy: this.state.orderBy,
      searchText: this.state.searchText,
    });
  };
  render() {
    const { contacts } = this.props;
    if (contacts && !contacts.contacts) {
      return null;
    }

    return (
      <Fragment>
        <Fragment>
          <Grid container>
            <Grid item xs={6} className="userActions">                

            <SecondaryButton
                onClick={this.download}
                aria-label="Add"
              >
                <ArrowDownward/> Download Table
              </SecondaryButton>
            </Grid>
            <Grid item xs={4} className="userActions" style={{textAlign:"right"}}>
              <TextField label="Search" type="text" name="searchText" value={this.state.searchText} onChange={this.handleChange} onKeyDown={this.handleKeyDown}/>
              <Button onClick={e => this.search()} className="button_TableActions _loansListEdit" ><SearchIcon /></Button>
            </Grid>
          </Grid>
        </Fragment>
        <Fade in>
          <Paper elevation={1}>
            <ContactTable contacts={this.props.contacts} onChangeRowsPerPage={this.handleChangeRowsPerPage} />
          </Paper>
        </Fade>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ authentication, contacts }) => ({
  authentication,
  contacts
});

export default connect(
  mapStateToProps,
  { getContacts, downloadContacts, getAllCompanies }
)(Contacts);
